<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" text="friendRequest" />
      </v-col>
    </v-row>

    <v-sheet>
      <div class="mt-4">
        <v-chip class="mx-1" @click="goToFriend('recommend')">{{
          $t("friendRecommend")
        }}</v-chip>
        <v-chip
          class="mx-1"
          @click="goToFriend('request')"
          :color="site.color"
          dark
          style="box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px"
          >{{ $t("friendRequest") }}</v-chip
        >

        <v-chip class="mx-1" @click="goToFriend('friend')">{{
          $t("friendList")
        }}</v-chip>
      </div>

      <v-container class="pt-0 mt-2">
        <v-row class="mt-1" v-if="dataRequest.length > 0">
          <v-col
            v-for="(item, index) in dataRequest"
            :key="index"
            class="px-2 py-2 display-card"
            cols="6"
            sm="4"
            lg="2"
            md="3"
          >
            <v-card
              class="rounded-lg py-1 px-1 card-container"
              outlined
              elevation="1"
              style="width: 100%; border: none"
            >
              <v-img
                :cover="true"
                :aspect-ratio="1"
                height="150px"
                :src="
                  item.user.profile_path
                    ? item.user.profile_path
                    : 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'
                "
              >
              </v-img>
              <p
                v-for="(data, j) in cardTitleFriend"
                :key="j"
                class="mb-0 ml-2"
              >
                <span
                  v-if="j == 0"
                  class="text-start mb-auto text-subtitle-2 black--text mb-0"
                >
                  {{ item.detail ? item.detail[data] : "-" }}
                </span>
                <span
                  v-else
                  style="font-size: 11px !important"
                  class="text-start mb-auto text-subtitle-2 black--text mb-0"
                >
                  {{ item.detail ? item.detail[data] : "-" }}
                </span>
              </p>
              <div style="display: grid" class="mx-auto pa-1">
                <v-btn
                  depressed
                  color="primary"
                  small
                  class="my-1"
                  style="border-radius: 8px"
                  @click="acceptFriend(item)"
                >
                  {{ $t("confirmDefault") }}
                </v-btn>
                <v-btn
                  depressed
                  color="gray"
                  small
                  class="my-1"
                  style="border-radius: 8px"
                  @click="cancelFriend(item)"
                >
                  ลบ
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <div v-else>
          <v-col class="d-flex justify-center mt-16">
            <v-img
              class="white--text mx-auto mt-10 empty"
              :src="require('@/assets/images/out-of-stock.png')"
              max-width="150px"
            >
            </v-img>
          </v-col>
          <p class="text-center">{{ $t("errDataNotFound") }}</p>
        </div>
      </v-container>
    </v-sheet>
  </v-container>
</template>
  
<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import HeaderTextBg from "../headerTextBg.vue";
export default {
  name: "listRequestFriend",
  components: { HeaderTextBg },
  data() {
    return {
      dataRequest: [],
      cardTitleFriend: [],
    };
  },

  mounted() {},

  methods: {
    getFriendRequest() {
      Axios.get("friend/getRequestFriend").then((res) => {
        this.dataRequest = res.data.data.data;
        this.cardTitleFriend = res.data.data.card_profile.split(",");
      });
    },
    acceptFriend(item) {
      Axios.post("friend/acceptFriend", { friend_id: item.id }).then((res) => {
        this.getFriendRequest();
        this.$swal.fire({
          icon: "success",
          text: res.data.message,
          showConfirmButton: false,
          timer: 2000,
        });

        this.$router.push({ name: "friend-list" });
      });
    },
    cancelFriend(item) {
      Axios.post("friend/cancelFriend", { friend_id: item.id }).then(() => {
        this.getFriendRequest();
      });
    },
    goToFriend(text) {
      if (text == "request") {
        this.$router.push({ name: "friend-request" });
      } else if (text == "recommend") {
        this.$router.push({ name: "friend-recommend" });
      } else {
        this.$router.push({ name: "friend-list" });
      }
    },
  },
  created() {
    this.getFriendRequest();
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
  },
};
</script>
  
<style>
.display-card {
  display: flex;
  justify-content: start !important;
}
</style>
